"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockRetailCustomers = exports.mockSerializedRetailCustomers = void 0;
const faker = require("faker");
const RetailCustomer_1 = require("../../../models/RetailCustomer");
exports.mockSerializedRetailCustomers = [
    {
        id: "122334",
        retailCustomerId: "122334",
        name: "John Smith",
        mobileNumber: "0440111222",
        birthDate: "1990-10-01",
        email: "john.smith@example.com",
        address: {
            fullAddress: "123 Awesome St Sydney NSW 2000",
            streetAddress: "123 Awesome St",
            suburb: "Sydney",
            state: "NSW",
            country: "Australia",
            postcode: "2000",
            lat: -36.0814035,
            lng: 146.920463
        },
        defaultNotes: faker.random.words(20),
        passwordHash: "zambrero",
        receiveNotifications: true,
        receiveMarketing: true,
        paydockCustomerId: "5dc0c9df71a3e413700d2a56",
        active: true,
        suspend: false
    },
    {
        id: "123456",
        retailCustomerId: "123456",
        name: "Martin Jackson",
        mobileNumber: "0440111222",
        birthDate: "1990-05-01",
        email: "martin.jackson@example.com",
        address: {
            fullAddress: "123 Awesome St Sydney NSW 2000",
            streetAddress: "123 Awesome St",
            suburb: "Sydney",
            state: "NSW",
            country: "Australia",
            postcode: "2000",
            lat: -31.9422222,
            lng: 115.9241667
        },
        passwordHash: "zambrero",
        receiveNotifications: true,
        receiveMarketing: true,
        paydockCustomerId: "5dc0c9df71a3e413700d2a56",
        active: true,
        suspend: false
    }
];
exports.mockRetailCustomers = exports.mockSerializedRetailCustomers.map(retailCustomer => RetailCustomer_1.RetailCustomer.unserialize(retailCustomer));
//# sourceMappingURL=mockRetailCustomers.js.map